import React from 'react'

import MissingComponent from './MissingComponent'

import InputField from './Mui/MuiTextField'
import RadioGroupField from './Mui/MuiRadioGroup'
import MultiselectField from './Mui/MuiMultiselectField'

const DateField = (props) => <InputField mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]} {...props} />
const TextareaField = (props) => <InputField multiline rows={4} {...props} />

let muiComponentsMap = {
  DateField,
  TextareaField,
  RadioGroupField,
  MultiselectField,
  InputField
}

export const muiLookupComponent = component => {
  return muiComponentsMap[component] || MissingComponent
}
export const muiRegisterComponents = obj => {
  muiComponentsMap = {
    ...muiComponentsMap,
    ...obj
  }
}
